import DataTable from 'datatables.net-bs5';
import language from 'datatables.net-plugins/i18n/pl.js';
import * as Spinner from "./spinner-tools";

Spinner.init();
// language.paginate.first = '<<';
// language.paginate.last = '>>';
// language.paginate.previous = '<';
// language.paginate.next = '>';


if ($('.orders-table').length) {
    window.spinner.show($('body'));
}

let OrderDataTables = new DataTable('.orders-table', {
    language: language,
    select: {
        className: 'form-select'
    },
    columns: [
        {data: 'id'},
        {data: 'date'},
        {data: 'status'},
        {data: 'price'},
        {data: 'payment'},
        {data: 'shipment'},
        {data: 'action', searchable: false, sortable: false},
        {data: 'reorder', searchable: false, sortable: false},
    ],
    order: [[0, 'desc']],
    ajax: {
        url: '/moje-konto/zamowienia/pobierz',
        type: 'POST',
        data: function (d) {
                if (window.location.pathname.match(/archiwalne/)) {
                    d.archive = 1;
                } else if (window.location.pathname.match(/zrealizowane/)) {
                    d.archive = 2;
                } else {
                    d.archive = 0;
                }
                d.length = $('#dt-length-0').val();
                d.status = $('.status').val();
                d.paymant = $('.payment').val();
                d.delivery = $('.delivery').val();
                return d;
            }
    },
    paging: true, // Table pagination
    ordering: true, // Column ordering
    info: true, // Bottom left status text
    responsive: true, // https://datatables.net/extensions/responsive/examples/
    searching: true,
    processing: true,
    serverSide: true,
    initComplete: function (settings, json) {
        OrderDataTables.columns().flatten().each(function (colIdx) {
            if (colIdx === 2) {
                createSelect(OrderDataTables.column(colIdx), json.statuses, 'status');
            }
            if (colIdx === 4) {
                createSelect(OrderDataTables.column(colIdx), json.payments, 'payment');
            }
            if (colIdx === 5) {
                createSelect(OrderDataTables.column(colIdx), json.deliveries, 'delivery');
            }
        });
        $('.cancel-order-btn-modal').on('click', function (e) {
            let orderId = $(e.target).data('order-id')
            $('#cancel-order-modal .cancel-order-btn').attr('href', orderId);
        })
        window.spinner.hide()
    },
});

let createSelect = function (column, data, className = '') {
    let select = $('<select><option value="">' + $(column.header()).html() + '</option></select>')
        .addClass('form-select ' + className)
        .appendTo(
            column.footer()
        )
        .on('change', function () {
            column
                .search($(this).val())
                .draw();
        });
        $.each(data,function(index,d){
            select.append($('<option value="' + index + '">' + d + '</option>'));
        });
}

export {
    OrderDataTables
}
